// noinspection DuplicatedCode

import helper from "../helper/cruiseStoreHelper";
import objectUtils from "../../util/objectUtils";
import messagePopupManager from "../../util/messagePopupManager";
import axios from "axios";
import Vue from "vue";

export default {
    state: () => ({
        cruiseList : null,
        cruise : null,

        cruiseRoomList : null,
        cruiseRoom : null,

        roomList : null,
        room : null,

        cabinTypeList : null,

        deckList : null,
        deck : null,
    }),
    mutations: {
        setCabinTypeList:function (state, cabinTypeList){
            state.cabinTypeList = cabinTypeList;
        },
        setCruiseList:function (state, cruiseList){
            state.cruiseList = cruiseList;
        },
        setCruise:function (state, cruise){
            state.cruise = cruise
        },
        setCruiseRoomList:function (state, cruiseRoomList){
            state.cruiseRoomList = cruiseRoomList;
        },
        setCruiseRoom:function (state, cruiseRoom){
            state.cruiseRoom = cruiseRoom
        },
        setRoomList:function (state, roomList){
            Vue.set(state,"roomList", roomList);
        },
        setRoom:function (state, room){
            state.room = room
        },
        setDeckList:function (state, deckList){
            state.deckList = deckList;
        },
        setDeck:function (state, deck){
            state.deck = deck
        },
    },
    getters: {
        getCabinTypeList : state => {
            return state.cabinTypeList
        },
        getCruiseList : state => {
            return state.cruiseList
        },
        getCruise : state => {
            return state.cruise
        },
        getCruiseRoomList : state => {
            return state.cruiseRoomList
        },
        getCruiseRoom : state => {
            return state.cruiseRoom
        },
        getRoomList : state => {
            return state.roomList
        },
        getRoomListMap : state => {
            if(state.roomList == null){
                return null;
            }
            return state.roomList.reduce(function (map, cabinType) {
                map[cabinType.id] = cabinType;
                return map;
            }, {});
        },
        getCruiseRoomMap : state => {
            if(state.cruiseRoomList == null){
                return null;
            }
            return state.cruiseRoomList.reduce(function (map, cruiseRoom) {
                map[cruiseRoom.id] = cruiseRoom;
                return cruiseRoom;
            }, {});
        },
        getRoom : state => {
            return state.room
        },
        getDeckList : state => {
            return state.deckList
        },
        getDeck : state => {
            return state.deck
        }
    },
    actions:{
        loadCruiseList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cruise", {headers})
                .then((response) => {
                    context.commit("setCruiseList", response.data);
                    return response.data;
                })
        },
        loadCruise(context, cruiseId){
            if(cruiseId === undefined){
                cruiseId = 1;
            }
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cruise/"+cruiseId, {headers})
                .then((response) => {
                    context.commit("setCruise", response.data);
                    return response.data;
                })
        },
        createCruise : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/cruise", request,{headers})
                .then((response) => {
                    context.commit("setCruise", response.data);
                    return response.data;
                })
        },
        updateCruise(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/cruise", request,{headers})
                .then((response) => {
                    
                    context.commit("setCruise", response.data);
                    return response.data;
                })
        },
        loadCruiseRoomList(context, cruiseId){
            if(cruiseId === undefined){
                cruiseId = 1;
            }
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cruise/"+cruiseId+"/cruiseRooms", {headers})
                .then((response) => {
                    context.commit("setCruiseRoomList", response.data);
                    return response.data;
                })
        },
        deleteCruiseRoom(context, cruiseRoom){

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/cruise/cruiseRoom/"+cruiseRoom.id, {headers})
                .then((response) => {
                    let cruiseRoomList = context.getters.getCruiseRoomList
                    cruiseRoomList.splice(cruiseRoomList.indexOf(cruiseRoom), 1)
                    context.commit("setCruiseRoomList", cruiseRoomList);
                    messagePopupManager.showSuccess()

                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        createCruiseRoom(context, cruiseRoom){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/cruise/cruiseRoom", cruiseRoom,{headers})
                .then((response) => {
                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        updateCruiseRoom(context, cruiseRoom){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/cruise/cruiseRoom", cruiseRoom,{headers})
                .then((response) => {
                    let cruiseRoomList = context.getters.getCruiseRoomList;
                    cruiseRoomList.forEach((cruiseRoom) => {
                        if(cruiseRoom.id === response.data.id) {
                            objectUtils.deepCopy(cruiseRoom, response.data);
                        }
                    });

                    context.commit("setCruiseRoomList", cruiseRoomList)

                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        loadRoomList(context, cruiseId){
            if(cruiseId === undefined){
                cruiseId = 1;
            }
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cruise/"+cruiseId+"/rooms", {headers})
                .then((response) => {
                    context.commit("setRoomList", response.data);
                    return response.data;
                })
        },
        deleteRoom(context, room){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/cruise/room/"+room.id, {headers})
                .then((response) => {
                    let roomList = context.getters.getRoomList
                    roomList.splice(roomList.indexOf(room), 1)
                    context.commit("setRoomList", roomList);
                    messagePopupManager.showSuccess()

                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        createRoom(context, room){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            room.cruiseId = context.getters.getCruise.id;
            return axios.post(context.getters.getServiceUrl + "/admin-api/cruise/room", room,{headers})
                .then((response) => {
                    let roomList = context.getters.getRoomList;
                    roomList.push(response.data);
                    context.commit("setRoomList", roomList)

                    return response.data;
                }).catch(error => {
                    helper.checkCreateResponseCodeAndShowPopup(error.response.data.code);
                })
        },
        updateRoom(context, room){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            if(room.imageUrl.startsWith("http")){
                room.imageUrl = null;
            }

            // let imageUrl = room.imageUrl;
            room.cruiseId = context.getters.getCruise.id;
            return axios.put(context.getters.getServiceUrl + "/admin-api/cruise/room", room,{headers})
                .then((response) => {
                    // if(imageUrl.startsWith("http")){
                    //     room.imageUrl = imageUrl;
                    // }else{
                    room.imageUrl = response.data.imageUrl;
                    // }

                    let roomList = context.getters.getRoomList;
                    roomList.forEach((room) => {
                        if(room.id === response.data.id) {
                            objectUtils.deepCopy(room, response.data);
                        }
                    });

                    context.commit("setRoomList",roomList)

                    return response.data;
                })
        },
        loadDeckList(context, cruiseId){
            if(cruiseId === undefined){
                cruiseId = 1;
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cruise/"+cruiseId+"/deck", {headers})
                .then((response) => {
                    context.commit("setDeckList", response.data);
                    return response.data;
                })
        },
        deleteDeck(context, deck){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/cruise/deck/"+deck.id, {headers})
                .then((response) => {
                    let deckList = context.getters.getDeckList
                    deckList.splice(deckList.indexOf(deck), 1)
                    context.commit("setDeckList", deckList);
                    messagePopupManager.showSuccess()
                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        createDeck(context, deck){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            deck.cruiseId = context.getters.getCruise.id
            return axios.post(context.getters.getServiceUrl + "/admin-api/cruise/deck",deck, {headers})
                .then((response) => {
                    let deckList = context.getters.getDeckList;
                    deckList.push(response.data);
                    context.commit("setDeckList", deckList);
                    return response.data;
                }).catch(error => {
                    helper.checkDeleteResponseCodeAndShowPopup(error.code);
                })
        },
        updateDeck(context, deck){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            let imageUrl = deck.imageUrl;
            if(deck.imageUrl.startsWith("http")){
                deck.imageUrl = null;
            }

            return axios.put(context.getters.getServiceUrl + "/admin-api/cruise/deck",deck, {headers})
                .then((response) => {
                    if(imageUrl.startsWith("http")){
                        deck.imageUrl = imageUrl;
                    }else{
                        deck.imageUrl = response.data.imageUrl;
                    }

                    let deckList = context.getters.getDeckList;
                    deckList.forEach((deck) => {
                        if(deck.id === response.data.id) {
                            objectUtils.deepCopy(deck, response.data);
                        }
                    });

                    context.commit("setDeckList", deckList)
                    return response.data;
                })
        },
        loadCabinTypeList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/cabinType", {headers})
                .then((response) => {
                    context.commit("setCabinTypeList", response.data);
                    return response.data;
                })
        },
    }
}

